import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { fixGridAndFilterBuilder } from 'react/utils/utils';
import ChatIcon from 'static/images/chat/chatIcon.svg';
import ResourceCenterIcon from 'static/images/resource-center.svg';

import MiniDashboard from 'react/containers/layout/Bottom/miniDashboard';
import SuspenseActionsTabs from './suspenseActionsTabs';

function SuspenseActions({
  suspenseActionsIsOpen,
  toggleSuspenseActions,
  miniDashboardIsOpen,
  toggleMiniDashboard
}) {
  const handleToggleSuspeseActions = () => {
    toggleSuspenseActions(!suspenseActionsIsOpen);
  };

  function handleToogleDashboard() {
    toggleMiniDashboard(!miniDashboardIsOpen);
  }

  useEffect(() => {
    const fixGridTimeout = setTimeout(() => {
      fixGridAndFilterBuilder();
    }, 100);

    return () => {
      clearTimeout(fixGridTimeout);
    };
  }, [suspenseActionsIsOpen, miniDashboardIsOpen]);

  const validatePendo = useCallback(() => {
    if (typeof window.pendo !== 'undefined') {
      return window.pendo.isReady();
    }
    return false;
  }, []);

  const pendoExists = validatePendo();

  return (
    <>
      <SuspenseActionsTabs
        suspenseActionsIsOpen={suspenseActionsIsOpen}
        toggleSuspenseActions={handleToggleSuspeseActions}
      />
      <MiniDashboard
        toggleDashboard={handleToogleDashboard}
        miniDashboardIsOpen={miniDashboardIsOpen}
      />
      <div
        className="usersListToggleButton"
      >
        <button
          data-testid="users-list-toggle-button"
          type="button"
          className="chatIconButton"
          onClick={handleToggleSuspeseActions}
        >
          <img src={ChatIcon} alt="Chat Icon" />
        </button>
      </div>
      {pendoExists && (
        <div className="pendoResource">
          <button
            data-testid="pendo-resource-button"
            className="pendo-resource-button"
            type="button"
          >
            <img src={ResourceCenterIcon} alt="Pendo Resource Icon" />
          </button>
        </div>
      )}
    </>
  );
}

SuspenseActions.propTypes = {
  miniDashboardIsOpen: PropTypes.bool.isRequired,
  suspenseActionsIsOpen: PropTypes.bool.isRequired,
  toggleSuspenseActions: PropTypes.func.isRequired,
  toggleMiniDashboard: PropTypes.func.isRequired
};

export default SuspenseActions;
